import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';

const MainBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;

    @media (max-width: 768px) {
    padding-top: 10px;
    h3{
      font-size: 16px;
      text-align: center;
    }
  }

`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 50px 100px;
  gap: 50px;
  flex-wrap: wrap;
  
`;

const Title = styled.div`
  font-size: 24px;
  color: #385963;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
  @media (max-width: 768px) {
     font-size: 18px;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 350px;
  padding: 30px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f9f9f9, #ffffff);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  max-height: 600px;

 

  &:hover {
    transform: translateY(-5px);
  }

`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  heght: 500px;
    overflow-y: auto;
      /* Optional: Custom scrollbar for WebKit browsers */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 6px;
  }

  
 
`;

const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #385963;
    @media (max-width: 768px) {
     font-size: 14px;
  }
`;

const Checkbox = styled.input`
  margin-right: 10px;
  accent-color: #6895e3;
`;

const DataAction = styled.button`
  background: none;
  border: none;
  color: #385963;
  font-size: 14px;
  cursor: pointer;
  margin-top: 10px;

  &:hover {
    text-decoration: underline;
    color: #91abb3;
  }
`;

const CardHeader = styled.div`
  padding: 10px 20px;
  border-bottom: 1px solid #eee;
`;

const ScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`;

const CardFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
  background-color: #fff;
  display: flex;
  flex-direction:column;
`;

const RemoveIcon = styled(Trash2)`
  margin-left: auto;
  cursor: pointer;
  color: #e57373;
  &:hover {
    color: #d32f2f;
  }
`;

const UpdateButton = styled.button`
  background-color: #4caf50;
  color: white;
  font-size: 14px;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #388e3c;
  }
  
  @media (max-width: 768px) {
   font-size: 12px;
  }
`;


const ClearButton = styled.button`
  background-color: #e53935;
  color: white;
  font-size: 14px;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #c62828;
  }

  @media (max-width: 768px) {
   font-size: 12px;
  }
`;



const PointsVisited = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const tokenString = sessionStorage.getItem('token');
  const { i18n } = useTranslation();

  const [destinations, setDestinations] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [visitedDestinations, setVisitedDestinations] = useState([]);
  const [visitedExperiences, setVisitedExperiences] = useState([]);

  const handleClear = async (type) => {
  const isDestination = type.includes('Destination');
  const list = isDestination ? visitedDestinations : visitedExperiences;
  const setList = isDestination ? setVisitedDestinations : setVisitedExperiences;
  const url = `${BASE_URL}RegisteredUserProfile/remove${type}`;

  if (list.length === 0) return; // Skip if nothing to remove

  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenString}`,
      },
      body: JSON.stringify(list),
    });

    if (response.ok) {
      setList([]); // Clear local state only if server succeeded
    } else {
      console.error(`Failed to clear ${type}`);
    }
  } catch (error) {
    console.error(`Error clearing ${type}:`, error);
  }
};


  useEffect(() => {
    const fetchUserProfile = async () => {
      const response = await fetch(`${BASE_URL}RegisteredUserProfile/get`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenString}`,
        },
      });
      const data = await response.json();
      setVisitedDestinations(data.destinationsVisited || []);
      setVisitedExperiences(data.experiencesVisited || []);
    };

    const fetchAllData = async () => {
      const [destRes, expRes] = await Promise.all([
        fetch(`${BASE_URL}Destination`),
        fetch(`${BASE_URL}Experience`),
      ]);
      setDestinations(await destRes.json());
      setExperiences(await expRes.json());
    };

    fetchUserProfile();
    fetchAllData();
  }, [BASE_URL, tokenString]);

  const toggleVisited = (id, list, setList) => {
    if (list.includes(id)) {
      setList(list.filter((item) => item !== id));
    } else {
      setList([...list, id]);
    }
  };

  const handleUpdate = async (type) => {
    const url = `${BASE_URL}RegisteredUserProfile/add${type}`;
    const list = type.includes('Destination') ? visitedDestinations : visitedExperiences;

    await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenString}`,
      },
      body: JSON.stringify(list),
    });
  };

const handleRemove = async (type, id) => {
  const isDestination = type.includes('Destination');
  const list = isDestination ? visitedDestinations : visitedExperiences;
  const setList = isDestination ? setVisitedDestinations : setVisitedExperiences;
  const url = `${BASE_URL}RegisteredUserProfile/remove${type}`;

  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenString}`,
      },
      body: JSON.stringify([id]),
    });

    if (response.ok) {
      setList(list.filter((item) => item !== id));
    } else {
      console.error(`Failed to remove item from ${type}`);
    }
  } catch (error) {
    console.error(`Error removing item from ${type}:`, error);
  }
};

  return (
    <MainBox>
      <h3>{i18n.t('selectPointsVisited')}</h3>
      <Container>
        <Card>
           <CardHeader>
            <Title>{i18n.t('destinations')}</Title>
          </CardHeader>
          <CheckboxContainer>
            {destinations.map((d) => (
             <CheckboxRow key={d.id}>
               <Checkbox
                 type="checkbox"
                 checked={visitedDestinations.includes(d.id)}
                 onChange={() => toggleVisited(d.id, visitedDestinations, setVisitedDestinations)}
               />
               {d.name[selectedLanguage]}
               {visitedDestinations.includes(d.id) && (
                 <RemoveIcon
                   size={16}
                   onClick={() => handleRemove('DestinationsVisited', d.id)}
                   title={i18n.t('remove')}
                 />
               )}
             </CheckboxRow>
            ))}

          </CheckboxContainer>
          <CardFooter>
            <UpdateButton onClick={() => handleUpdate('DestinationsVisited')}>
              {i18n.t('updatePreferences')}
            </UpdateButton>
            <ClearButton onClick={() => handleClear('DestinationsVisited')}>
              {i18n.t('clear')}
            </ClearButton>
          </CardFooter>

        </Card>

        <Card> 
          <CardHeader>
            <Title>{i18n.t('experiences')}</Title>
          </CardHeader> 
          <CheckboxContainer>
            {experiences.map((e) => (
              <CheckboxRow key={e.id}>
                <Checkbox
                  type="checkbox"
                  checked={visitedExperiences.includes(e.id)}
                  onChange={() => toggleVisited(e.id, visitedExperiences, setVisitedExperiences)}
                />
                {e.name[selectedLanguage]}
                {visitedExperiences.includes(e.id) && (
                  <RemoveIcon
                    size={16}
                    onClick={() => handleRemove('ExperiencesVisited', e.id)}
                    title={i18n.t('remove')}
                  />
                )}
              </CheckboxRow>
            ))}
          </CheckboxContainer>
          <CardFooter>
            <UpdateButton onClick={() => handleUpdate('ExperiencesVisited')}>
              {i18n.t('updatePreferences')}
            </UpdateButton>
            <ClearButton onClick={() => handleClear('ExperiencesVisited')}>
              {i18n.t('clear')}
            </ClearButton>
          </CardFooter>

        </Card>
      </Container>
    </MainBox>
  );
};

export default PointsVisited;

